var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.2 12.8",
    style: {
      enableBackground: "new 0 0 21.2 12.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(53 175)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-47.7-167c0,0.6,0.1,1.1,0.2,1.6h-0.8c-2.6,0-4.8-2.1-4.8-4.8s2.1-4.8,4.8-4.8h5.3c2.6,0,4.8,2.1,4.8,4.8 s-2.1,4.8-4.8,4.8h-0.3c-0.5-0.4-0.7-1-0.7-1.6h1.1c1.8,0,3.2-1.4,3.2-3.2s-1.4-3.2-3.2-3.2h-5.3c-1.8,0-3.2,1.4-3.2,3.2 s1.4,3.2,3.2,3.2C-48.2-167-47.7-167-47.7-167z M-31.8-167c0,2.6-2.1,4.8-4.8,4.8h-5.3c-2.6,0-4.8-2.1-4.8-4.8s2.2-4.8,4.8-4.8 h0.3c0.4,0.4,0.7,1,0.7,1.6h-1.1c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2h5.3c1.8,0,3.2-1.4,3.2-3.2s-1.4-3.2-3.2-3.2h-0.5 c0-0.6-0.1-1.1-0.2-1.6h0.8C-33.9-171.8-31.7-169.7-31.8-167L-31.8-167z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLink);
export default __webpack_public_path__ + "static/media/map-link.5e4650d5.svg";
export { ForwardRef as ReactComponent };